<script setup lang="ts">
    const props = defineProps<{ blok: TableRowStoryblok }>();
</script>

<template>
    <tr v-editable="props.blok">
        <template
            v-for="(blokComponent, index) in props.blok.tableCells"
            :key="'cell-' + index"
        >
            <th
                v-if="blok.hasRowHeader && index === 0"
                scope="row"
            >
                <StoryblokComponentWrapper :blok="blokComponent" />
            </th>
            <td v-else>
                <StoryblokComponentWrapper :blok="blokComponent" />
            </td>
        </template>
    </tr>
</template>

<style lang="scss" scoped>
    @import '~/assets/scss/table/table.scss';
</style>
